import React, { PropsWithChildren } from 'react'
import { useTranslation } from 'react-i18next'
import { StatusCard } from '@node-space/storybook-components/dist/StatusCard'
import { TextAction } from '@node-space/storybook-components/dist/TextAction'
import { Box, Illustration, Text } from '@node-space/ui-components'
import { ExternalLinks } from 'constants/links'

export interface RequestErrorStatusCardProps extends PropsWithChildren {
  title?: string
  borderless?: boolean
  noPadding?: boolean
  onReload?: () => void
}

export const RequestErrorStatusCard = ({
  title,
  borderless,
  noPadding,
  children,
  onReload,
}: RequestErrorStatusCardProps) => {
  const { t } = useTranslation()

  return (
    <StatusCard
      customIcon={<Illustration name="CloudLightning" color="error" />}
      headline={title ?? t('errorMessages.getErrorTitle')}
      borderless={borderless}
      {...(noPadding && { className: '!p-0' })}
    >
      <Box className="max-w-lg">
        {children ?? (
          <Text isCentered>
            {`${t('errorMessages.weApologiseForInconvenience')} ${t('errorMessages.pleaseTryTo')} `}
            {onReload ? (
              <TextAction onClick={onReload} text={t('errorMessages.reloadData')} />
            ) : (
              <TextAction isWindowReload text={t('errorMessages.reload')} />
            )}
            {`. ${t('errorMessages.ifTheProblemPersists')}, `}
            <TextAction
              linkTo={ExternalLinks.CONTACT_SUPPORT}
              text={t('errorMessages.contactSupport')}
            />
            {` ${t('errorMessages.tryLater')}.`}
          </Text>
        )}
      </Box>
    </StatusCard>
  )
}
